(function($) {
	$(function() {
		$('.js-scroll-top').click(function() {
			$('html, body').stop().animate({scrollTop: 0},800);
			return false;
		})
  });
  window.addEventListener('scroll', function() {
    let elem = document.querySelector('.js-scroll-top');
    if(pageYOffset > 100) {
      elem.classList.remove('disable');
    } else {
      elem.classList.add('disable');
    }
  });
})(jQuery);